import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../atoms/utilsAtoms';
import { useSwrData } from './swrWrapper';
import { mutate } from 'swr';
import { disableRevalidationForSwrOptions } from '../utils/globals';

const getVideoUrl = videoId => {
	return `${import.meta.env.VITE_APP_API_URL}/playerpage/video?query=${videoId}`;
};

export const useFetchCategories = token => {
	const url = `${import.meta.env.VITE_APP_API_URL}/category`;
	const { data, error, mutate, isLoading } = useSwrData(url, token, disableRevalidationForSwrOptions);

	return {
		videoTypes: data || [],
		isLoading,
		isError: error,
		refreshCategories: mutate
	};
};

export const useFetchVideoById = videoId => {
	if (!videoId) return { data: null };

	const userData = useAtomValue(userInfoAtom);
	if (!userData.token) return { data: null };

	const url = getVideoUrl(videoId);
	return useSwrData(url, userData.token, disableRevalidationForSwrOptions);
};

export const mutateFetchVideoById = async (videoId, token) => {
	if (!videoId) return;

	const url = getVideoUrl(videoId);
	mutate({ url, token: token });
};
